<template>
    <router-view>
        <slot />
    </router-view>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'app',
    methods: {
      ...mapActions([
        'updateStocks'
      ])
    },
    created () {
      this.updateStocks()
    }
  }
</script>

<style lang="scss">
    @import './assets/styles/app';
</style>



// WEBPACK FOOTER //
// App.vue?2b1ceec6